import { RouterProvider } from 'react-router-dom';
import { router } from '../../Routing';
import { Suspense, lazy } from 'react';
import { useMsal } from '@azure/msal-react';
import { UserEnum } from '@/state/interface';
import SkeletonCard from '@components/Skeleton';
import UnauthorisedLogin from '@pages/UnauthorisedLogin';
import { NotificationType, POPUP_CONFIG } from '@constants/notification.constants';
import PopUp, { Slide, PopUpPosition } from '@components/PopUp';
import { getNotificationDescHtml } from '@helpers/notification.helper';
import { isIOS, isAndroid, isMobile } from 'react-device-detect';

const Logo = lazy(() => import('@assets/images/logo/logo-rounded.svg'));

type MainLayoutProps = {
	isInstallAvailable: boolean;
	isInstallPromptHidden: boolean;
	hideInstallPrompt: () => void;
	dismissInstallPrompt: () => void;
	install: () => void;
	isStandaloneMode: boolean;
};

export default function MainLayout({
	isInstallAvailable,
	isInstallPromptHidden,
	hideInstallPrompt,
	dismissInstallPrompt,
	install,
	isStandaloneMode,
}: MainLayoutProps) {
	const { instance } = useMsal();
	const account = instance?.getActiveAccount();
	const userType = account?.idTokenClaims?.extension_entity_type;
	const descriptionHtml = getNotificationDescHtml(isIOS ? NotificationType.INSTALL_APPLE : NotificationType.INSTALL_ANDROID);

	return userType === UserEnum.OUTLET || userType === UserEnum.POS ? (
		<>
			<Suspense fallback={<SkeletonCard />}>
				<RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
			</Suspense>

			{/* Prompt to add to home screen */}
			{isInstallAvailable && !isInstallPromptHidden && isMobile && !isStandaloneMode && (
				<PopUp
					slideType={Slide.DOWN}
					popUpPosition={PopUpPosition.BOTTOM}
					isSticky={true}
					icon={<Logo />}
					classIcon='w-12 h-12'
					descriptionHtml={descriptionHtml}
					isCtaButton={isAndroid}
					ctaText={'Add'}
					onCtaClick={install}
					onClose={hideInstallPrompt}
					onDismiss={dismissInstallPrompt}
					delayTime={POPUP_CONFIG.DELAY_TIME[NotificationType.INSTALL_ANDROID]}
					displayDuration={POPUP_CONFIG.DISPLAY_DURATION}
				/>
			)}
		</>
	) : (
		<UnauthorisedLogin></UnauthorisedLogin>
	);
}
